/*
 * Adapptio Editor
 *
 * @package editor
 * @copyright 2021-2025 Hexio a.s. <contact@hexio.io> (hexio.io) and contributors.
 * @license Apache-2.0
 *
 * See LICENSE file distributed with this source code for more information.
 */

import React, { useCallback } from "react";
import { BEM } from "@adapptio/lib-components";

import "./FieldListBreadcrumb.scss";
import { isFunction } from "@adapptio/lib-shared";

export interface IFieldListBreadcrumbProps extends React.ComponentPropsWithoutRef<"div"> {
	className?: string;
	children?: React.ReactNode;
	disabled?: boolean;
	onClick?: React.MouseEventHandler;
}

export const FieldListBreadcrumb: React.FC<IFieldListBreadcrumbProps> = ({
	className,
	children,
	disabled,
	onClick,
	...props
}) => {
	const baseClass = BEM("edt-field-list-breadcrumb", null, {
		disabled
	});

	const handleClick = useCallback<React.MouseEventHandler>(
		(event) => {
			if (disabled) {
				return;
			}

			if (isFunction(onClick)) {
				onClick(event);
			}
		},
		[ disabled, onClick ]
	);

	if (className) {
		baseClass.add(className);
	}

	return (
		<span className={baseClass.toClassName()} onClick={handleClick} {...props}>
			{children}
		</span>
	);
};
